import { Calendar, CalendarProps } from 'primereact/calendar';
import { CalendarIcon } from '@src/assets/icons';
import { useMediaQuery } from '@mui/material';
import { format } from 'date-fns';
import { Nullable } from 'primereact/ts-helpers';
import { useRef } from 'react';
import OButton from '../OButton';

import './OCalendar.scss';

interface IOCalendarProp {
  onChange: (e: any) => void;
  value: Nullable<Date>;
  dateFormat?: string;
  calendarProps?: CalendarProps;
  classes?: {
    invalid: string;
  };
  showTime?: boolean;
  onShow?: () => void;
  onHide?: () => void;
}

const OCalendar = ({
  onChange,
  value,
  dateFormat = 'dd/mm/yy',
  classes,
  calendarProps = {},
  showTime = true,
  onShow,
  onHide,
}: IOCalendarProp) => {
  const isMobile = useMediaQuery('(max-width:768px)');
  const calendarRef = useRef<any>(null);

  const footerTamplete = () => {
    return (
      <div className="flex justify-center mt-2">
        <OButton onClick={closeCalendar} text="Set" variant="primary" size="x-medium" />
      </div>
    );
  };

  const closeCalendar = () => {
    if (calendarRef.current) {
      calendarRef.current.hide();
    }
  };

  return (
    <Calendar
      onShow={onShow}
      onHide={onHide}
      placeholder="Please enter date"
      ref={calendarRef}
      value={value}
      onChange={(e) => {
        onChange(e);
      }}
      className={`webinar-date ${classes?.invalid ? classes.invalid : ''}`}
      inputClassName="input-style"
      showTime={showTime}
      hourFormat="12"
      icon={<CalendarIcon />}
      showIcon
      readOnlyInput
      touchUI={isMobile ? true : false}
      formatDateTime={(date) => format(date, dateFormat)}
      footerTemplate={footerTamplete}
      {...calendarProps}
    />
  );
};

export default OCalendar;
